import type { EnvironmentName } from './types';

export const getSanityDataset = (env: EnvironmentName) => {
    if (env === 'prod' || env === 'staging') {
        return 'bilhold-production-public';
    }
    return 'bilhold-development-public';
};
